.visualLabel {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 8px;
}